import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  AfterViewInit,
  ChangeDetectorRef,
} from '@angular/core';
import { HelpersService } from '../../../../../services/helpers.service';
import { RentalsService } from '../../../../../services/rentals.service';
import { AppConfig } from '../../../../../app.config';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs/internal/Subject';
import { debounceTime } from 'rxjs/internal/operators/debounceTime';

declare let productFruits: any;

@Component({
  selector: 'app-rentals-reservations-summary',
  templateUrl: './rentals-reservations-summary.component.html',
  styleUrls: ['./rentals-reservations-summary.component.scss'],
})
export class RentalsReservationsSummaryComponent
  implements OnInit, AfterViewInit {
  @ViewChild('checklistContainer', { static: false }) checklistContainer!: ElementRef;
  @ViewChild('stickyContainer', { static: false }) stickyContainer: ElementRef;

  public selectedDate: Date = new Date();
  public fromDate: string = '';
  public toDate: string = '';
  public partner: any = {};
  public partnerID: string = '';
  public rentalsGoingOut: any = [];
  public rentalsReturning: any = [];
  public rentalDeliveries: any = [];
  public rentalCollections: any = [];
  public searchData: any = [];
  public countryData: any = {};
  public expandedReservation: any = {};
  public loading: boolean = false;
  public showRentalReservation: boolean = false;
  public selectedReservation: any = {};
  public categories: any = [];
  public brands: any = [];
  public sizes: any = [];
  public rentalStoreRules: any = {};
  public loadingConfig: boolean = true;
  public showBookRentalReservation: boolean = false;
  public bookingInfo: any = {};
  public rentalsConfigured: boolean = false;
  public dateRangeView: any = 'DAY';

  public rentalsGoingOutFiltered: any = [];
  public rentalsReturningFiltered: any = [];
  public rentalDeliveriesFiltered: any = [];
  public rentalCollectionsFiltered: any = [];
  public searchDataFiltered: any = [];
  public searchRequest: string = "";
  public summaries: any = [];
  public statuses: any = [];
  public selectedStatusFilter: any = [];
  public paymentStatuses: any = [];
  public selectedPaymentStatusFilter: any = [];
  public waiverStatuses: any = [];
  public selectedWaiverStatusFilter: any = [];
  public categoryFilters: any = [];
  public brandFilters: any = [];
  public selectedCategoryFilter: any = [];
  public selectedBrandFilter: any = [];
  public isSearch: boolean = false;
  private searchInputChanged: Subject<string> = new Subject<string>();
  public previousSearchRequest: string = "";



  private checklistId: string = this.appConfig.getProductFruitChecklistID();

  constructor(
    private helpersService: HelpersService,
    private rentalsService: RentalsService,
    private appConfig: AppConfig,
    private translate: TranslateService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {
    this.fromDate = moment(new Date()).format('YYYY-MM-DD');
    this.toDate = moment(new Date()).add(1, 'day').format('YYYY-MM-DD');
    this.selectedDate = moment(this.fromDate).toDate();
  }

  ngOnInit() {
    this.partner = this.helpersService.getPartnerData();
    this.partnerID = this.helpersService.getPartnerId();
    this.countryData = this.helpersService.getCountryData();
    this.getRentalConfig();

    this.searchInputChanged.pipe(
      debounceTime(300) // Wait for 300ms after the last change
    ).subscribe((searchText) => {
      this.getReservationsSummary(); // Trigger the search
    });

  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.initProductFruits();
      this.setupStickyHeader();
    }, 3000);
  }

  async initProductFruits() {
    if (!this.rentalsConfigured) {
      try {
        let checkists = await productFruits.api.checklists.getChecklists();
        const element = this.checklistContainer.nativeElement;
        let identity = productFruits.identifyUser({
          username: this.partnerID,
        });
        const isEligible =
          await productFruits.api.checklists.isChecklistEligible(
            this.checklistId,
            element,
          );

        if (isEligible === 'eligible') {
          // Inject the checklist into the specified element
          productFruits.api.checklists.injectToElement(
            this.checklistId,
            element,
          );
        }
      } catch (error) {
        console.error(error);
      }
    }
  }

  dateChanged(event) {
    this.fromDate = moment(this.selectedDate).format('YYYY-MM-DD');
    this.toDate = moment(this.selectedDate).add(1, 'day').format('YYYY-MM-DD');
    this.getReservationsSummary();
  }

  nextDate() {
    if (this.dateRangeView === 'DAY') {
      this.selectedDate = moment(this.selectedDate).add(1, 'day').toDate();
    } else if (this.dateRangeView === 'WEEK') {
      this.selectedDate = moment(this.selectedDate).add(7, 'day').toDate();
    } else if (this.dateRangeView === 'MONTH') {
      this.selectedDate = moment(this.selectedDate).add(1, 'month').toDate();
    }
    this.viewChanged(this.dateRangeView);
  }

  previousDate() {
    if (this.dateRangeView === 'DAY') {
      this.selectedDate = moment(this.selectedDate).add(-1, 'day').toDate();
    } else if (this.dateRangeView === 'WEEK') {
      this.selectedDate = moment(this.selectedDate).add(-7, 'day').toDate();
    } else if (this.dateRangeView === 'MONTH') {
      this.selectedDate = moment(this.selectedDate).add(-1, 'month').toDate();
    }
    this.viewChanged(this.dateRangeView);
  }

  setToday() {
    this.selectedDate = moment().toDate();
    this.viewChanged(this.dateRangeView);
  }

  getToDate() {
    return moment(this.toDate).add(-1, 'day').toDate();
  }

  viewChanged(dateRangeView) {
    moment.updateLocale('en', {
      week: {
        dow: 1,
      },
    });
    this.dateRangeView = dateRangeView;
    if (this.dateRangeView === 'DAY') {
      this.fromDate = moment(this.selectedDate).format('YYYY-MM-DD');
      this.toDate = moment(this.selectedDate)
        .add(1, 'day')
        .format('YYYY-MM-DD');
    } else if (this.dateRangeView === 'WEEK') {
      this.fromDate = moment(this.selectedDate)
        .startOf('week')
        .format('YYYY-MM-DD');
      this.toDate = moment(this.selectedDate)
        .endOf('week')
        .add(1, 'day')
        .format('YYYY-MM-DD');
    } else if (this.dateRangeView === 'MONTH') {
      this.fromDate = moment(this.selectedDate)
        .startOf('month')
        .format('YYYY-MM-DD');
      this.toDate = moment(this.selectedDate)
        .endOf('month')
        .add(1, 'day')
        .format('YYYY-MM-DD');
    }
    else if (this.dateRangeView === 'ALLACTIVE') {
      this.fromDate = '';
      this.toDate = '';
    }
    this.getReservationsSummary();
  }

  getRentalConfig() {
    this.loadingConfig = true;
    this.loading = true;
    this.rentalsService
      .getRentalConfiguration(this.helpersService.getPartnerId())
      .subscribe(
        async (config: any) => {
          this.rentalStoreRules = config;
          this.loadingConfig = false;

          if (config && config.defaultStoreTimes) {
            config.defaultStoreTimes.forEach((x) => {
              if (x.isWorking) {
                this.rentalsConfigured = true;
              }
            });
          }
          this.getReservationsSummary();
          this.getRentalProducts();
          if (!this.rentalsConfigured) {
            if (this.router.url == '/store/rentals/reservations-summary') {
              this.router.navigateByUrl(this.router.url + '-tour');
            }
          }

          if (this.router.url.toLowerCase().includes('/reservations-summary/create-reservation')) {
            this.addNewReservation();
          }
        },
        (err) => {
          this.loadingConfig = false;
        },
      );
  }

  getReservationsSummary(showLoader: boolean = true) {
    this.loading = showLoader ? true : false;
    this.rentalsService
      .getReservationsSummary(this.partner.ID, !this.searchRequest ? this.fromDate : "", !this.searchRequest ? this.toDate : "", !this.searchRequest ? this.dateRangeView === 'ALLACTIVE' : false, this.searchRequest)
      .subscribe(
        (summaries) => {
          this.rentalsGoingOut = summaries.rentalsGoingOut === null ? [] : summaries.rentalsGoingOut;
          this.rentalDeliveries = summaries.deliveries === null ? [] : summaries.deliveries;
          this.rentalsReturning = summaries.rentalsReturning === null ? [] : summaries.rentalsReturning;
          this.rentalCollections = summaries.collections === null ? [] : summaries.collections;
          this.searchData = summaries.searchResults === null ? [] : summaries.searchResults;

          this.rentalsGoingOutFiltered = summaries.rentalsGoingOut === null ? [] : summaries.rentalsGoingOut;
          this.rentalDeliveriesFiltered = summaries.deliveries === null ? [] : summaries.deliveries;
          this.rentalsReturningFiltered = summaries.rentalsReturning === null ? [] : summaries.rentalsReturning;
          this.rentalCollectionsFiltered = summaries.collections === null ? [] : summaries.collections;
          this.searchDataFiltered = summaries.searchResults === null ? [] : summaries.searchResults;

          this.loading = false;

          this.summaries = [].concat(
            this.rentalsGoingOut,
            this.rentalDeliveries,
            this.rentalsReturning,
            this.rentalCollections,
            this.searchData
          )

          if (this.searchRequest) {
            this.isSearch = true;
          } else {
            this.isSearch = false;
          }

          this.updateFilters();
          this.applyRentalFilters()
        },
        (err) => {
          this.loading = false;
        },
      );
  }

  getRentalProducts() {
    this.loading = true;
    this.rentalsService.getActiveRentalProducts(this.partner.ID).subscribe(
      (res) => {
        this.createFilterData(res);
      },
      (err) => { },
    );
  }

  createFilterData(results) {
    this.categories = results
      .map((product) => {
        return product.categoryName;
      })
      .filter(
        (v, i, a) =>
          a
            .map((x) => {
              return x;
            })
            .indexOf(v) === i,
      )
      .sort((x, y) => {
        if (x > y) return 1;
        if (x < y) return -1;
        return 0;
      });
    this.brands = results
      .map((product) => {
        return product.brand;
      })
      .filter(
        (v, i, a) =>
          a
            .map((x) => {
              return x;
            })
            .indexOf(v) === i,
      )
      .sort((x, y) => {
        if (x > y) return 1;
        if (x < y) return -1;
        return 0;
      });
    this.sizes = results
      .map((product) => {
        return product.size;
      })
      .filter(
        (v, i, a) =>
          a
            .map((x) => {
              return x;
            })
            .indexOf(v) === i,
      )
      .sort((x, y) => {
        if (x > y) return 1;
        if (x < y) return -1;
        return 0;
      });
  }

  addNewReservation() {
    if (
      moment(this.selectedDate).format('YYYY-MM-DD') ==
      moment().format('YYYY-MM-DD')
    ) {
      this.bookingInfo = {
        fromDate: moment(
          moment(new Date()).add(1, 'hour').format('YYYY-MM-DDTHH:00:00'),
        ).toDate(),
        toDate: moment(
          moment(new Date()).add(2, 'hour').format('YYYY-MM-DDTHH:00:00'),
        ).toDate(),
        linkedRentalProducts: [],
        deliveryInformation: {},
        collectionInformation: {},
      };
    } else {
      this.bookingInfo = {
        fromDate: moment(
          moment(this.selectedDate).format('YYYY-MM-DDT08:00:00'),
        ).toDate(),
        toDate: moment(
          moment(this.selectedDate).format('YYYY-MM-DDT10:00:00'),
        ).toDate(),
        linkedRentalProducts: [],
        deliveryInformation: {},
        collectionInformation: {},
      };
    }
    this.showBookRentalReservation = true;
  }

  closeNewReservation() {
    this.showBookRentalReservation = false;
    this.getReservationsSummary();
  }

  add(accumulator, a) {
    return accumulator + a;
  }

  updateFilters() {
    if (this.summaries) {
      this.statuses = this.summaries
        .map((x) => ({ value: x.reservationStatusID, label: x.reservationStatus || '' }))
        .filter((status, index, self) => index === self.findIndex((s) => (s.value === status.value && s.label === status.label)))
        .filter((x) => x.label !== '')
        .sort((a, b) => (a.label || '').localeCompare(b.label || ''));

      this.paymentStatuses = this.summaries
        .map((x) => ({ value: x.paymentStatusID, label: x.paymentStatus || '' }))
        .filter((status, index, self) => index === self.findIndex((s) => (s.value === status.value && s.label === status.label)))
        .filter((x) => x.label !== '')
        .sort((a, b) => (a.label || '').localeCompare(b.label || ''));

      this.waiverStatuses = this.summaries
        .map((reservation) => {
          if (reservation.reservationProducts) {
            const numberSigned = reservation.reservationProducts
              .map((x) => (x.waiverSigned ? 1 : 0))
              .reduce(this.add, 0);

            return {
              value:
                numberSigned === reservation.reservationProducts.length
                  ? 'all'
                  : numberSigned === 0
                    ? 'none'
                    : 'partial',
              label:
                numberSigned === reservation.reservationProducts.length
                  ? 'bikeshop.rentals.summary.waiver_signed_all'
                  : numberSigned === 0
                    ? 'bikeshop.rentals.summary.waiver_signed_none'
                    : 'bikeshop.rentals.summary.waiver_signed_partial',
            };
          } else {
            return {
              value: 'none',
              label: 'bikeshop.rentals.summary.waiver_signed_none',
            };
          }
        })
        .filter((status, index, self) => index === self.findIndex((s) => s.value === status.value && s.label === status.label))
        .map((x) => ({ value: x.value, label: this.translate.instant(x.label || '') || '' }))
        .filter((x) => x.label !== '')
        .sort((a, b) => (a.label || '').localeCompare(b.label || ''));


      this.categoryFilters = this.summaries
        .flatMap((x) => (x.reservationProducts || []).map((product) => product.categoryName || ''))
        .filter((categoryName, index, self) => categoryName && self.indexOf(categoryName) === index)
        .map((categoryName) => ({ value: categoryName, label: categoryName }))
        .filter((x) => x.label !== '')
        .sort((a, b) => (a.label || '').localeCompare(b.label || ''));

      this.brandFilters = this.summaries
        .flatMap((x) => (x.reservationProducts || []).map((product) => product.brand || ''))
        .filter((brand, index, self) => brand && self.indexOf(brand) === index)
        .map((brand) => ({ value: brand, label: brand }))
        .filter((x) => x.label !== '')
        .sort((a, b) => (a.label || '').localeCompare(b.label || ''));
    }
  }

  applyRentalFilters() {
    this.rentalsGoingOutFiltered = this.rentalsGoingOut.length == 0 ? [] : this.filterData(this.rentalsGoingOut);
    this.rentalsReturningFiltered = this.rentalsReturning.length == 0 ? [] : this.filterData(this.rentalsReturning);
    this.rentalDeliveriesFiltered = this.rentalDeliveries.length == 0 ? [] : this.filterData(this.rentalDeliveries);
    this.rentalCollectionsFiltered = this.rentalCollections.length == 0 ? [] : this.filterData(this.rentalCollections);
    this.searchDataFiltered = this.searchData.length == 0 ? [] : this.filterData(this.searchData);
  }

  filterData(data: any) {
    if (data && data.length > 0) {
      let filteredSummaries = data;

      if (this.selectedStatusFilter.length > 0) {
        filteredSummaries = filteredSummaries.filter((summary) =>
          this.selectedStatusFilter.includes(summary.reservationStatusID)
        );
      }

      if (this.selectedPaymentStatusFilter.length > 0) {
        filteredSummaries = filteredSummaries.filter((summary) =>
          this.selectedPaymentStatusFilter.includes(summary.paymentStatusID)
        );
      }

      if (this.selectedWaiverStatusFilter.length > 0) {
        filteredSummaries = filteredSummaries.filter((summary) => {
          const numberSigned = summary.reservationProducts ? summary.reservationProducts
            .map((x) => (x.waiverSigned ? 1 : 0))
            .reduce(this.add, 0) : 0;

          const waiverStatus = summary.reservationProducts ? (
            numberSigned === summary.reservationProducts.length ? 'all'
              : numberSigned === 0
                ? 'none'
                : 'partial'
          ) : 'none';

          return this.selectedWaiverStatusFilter.includes(waiverStatus);
        });
      }

      if (this.selectedCategoryFilter.length > 0) {
        filteredSummaries = filteredSummaries.filter((summary) => {
          if (!summary.reservationProducts) { summary.reservationProducts = []; }
          return summary.reservationProducts.some((product) =>
            this.selectedCategoryFilter.includes(product.categoryName))
        }
        );
      }

      if (this.selectedBrandFilter.length > 0) {
        filteredSummaries = filteredSummaries.filter((summary) => {
          if (!summary.reservationProducts) { summary.reservationProducts = []; }
          return summary.reservationProducts.some((product) =>
            this.selectedBrandFilter.includes(product.brand))
        }
        );
      }
      return filteredSummaries;
    }
  }

  isFiltersSet() {
    return (
      this.selectedStatusFilter.length > 0 ||
      this.selectedPaymentStatusFilter.length > 0 ||
      this.selectedWaiverStatusFilter.length > 0 ||
      this.selectedCategoryFilter.length > 0 ||
      this.selectedBrandFilter.length > 0 ||
      this.searchRequest.length > 0
    );
  }

  clearFilters() {
    this.selectedBrandFilter = [];
    this.selectedCategoryFilter = [];
    this.selectedStatusFilter = [];
    this.selectedPaymentStatusFilter = [];
    this.selectedWaiverStatusFilter = [];
    if (this.searchRequest.length > 0) {
      this.searchRequest = "";
      this.getReservationsSummary();
    } else {
      this.applyRentalFilters();
    }
    this.isSearch = false;
  }

  setupStickyHeader() {
    // Wait until elements are rendered
    setTimeout(() => {
      if (typeof window !== 'undefined') {
        const header = this.stickyContainer?.nativeElement;
        if (header) {
          // Create a sentinel element that will be positioned above the header
          const sentinel = document.createElement('div');
          // sentinel.style.position = 'absolute';
          // sentinel.style.top = '0';
          // sentinel.style.height = '1px';
          // sentinel.style.width = '100%';
          // sentinel.style.pointerEvents = 'none';

          // Insert the sentinel before the header
          header.parentNode.insertBefore(sentinel, header);

          // Observe the sentinel instead of the header itself
          const observer = new IntersectionObserver(
            ([entry]) => {
              if (!entry.isIntersecting) {
                header.classList.add('is-sticky');
              } else {
                header.classList.remove('is-sticky');
              }
            },
            { threshold: [0], rootMargin: '0px' }
          );

          observer.observe(sentinel);

        }
      }
    }, 50);
  }

  onSearchInputChange(value) {

    if (this.previousSearchRequest === "" && value.length >= 4) {
      this.searchInputChanged.next(value); // Emit the new value
    } else if (value === "" && this.previousSearchRequest.length > 0) {
      this.searchInputChanged.next(value); // Emit the new value
    }
    this.previousSearchRequest = value;
  }

}
